import React, { Fragment } from "react";
import CreateAdmin from "./CreateAdmin";

const Create_Admin = ({ handleCancel }) => {
  return (
    <Fragment>
      <CreateAdmin handleCancel={handleCancel} />
    </Fragment>
  );
};

export default Create_Admin;
